<template>
  <footer class="bg-gray-800 mt-20 text-white py-8 pb-[90px]">
    <div class="container mx-auto px-4">
      <div class="flex flex-col md:flex-row items-center justify-between mb-6">
        <div class="flex items-center mb-4 md:mb-0 ml-[-3px]">
          <img width="260" src="@/assets/web_logo.png" alt="" />
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div class="border-r border-gray-700 pr-4">
          <h3 class="text-xl font-bold mb-4 text-white">CONTACTS</h3>
          <ul class="text-sm space-y-2 text-gray-400">
            <li><i class="fa fa-phone mr-2"></i> 86-13715691313</li>
            <li><i class="fa fa-envelope mr-2"></i> info@deergifts.com</li>
            <li>
              <i class="fa fa-comment mr-2"></i> Whatsapp: 86-13715691313
            </li>
          </ul>
        </div>

        <div class="border-r border-gray-700 pr-4">
          <h3 class="text-xl font-bold mb-4 text-white">DONG FENG</h3>
          <p class="text-sm text-gray-400">
            <i class="fa fa-building mr-2"></i> ZHONGSHAN DEERGIFTS METAL PRODUCT CO., LTD.<br />
            No. 9, Lane 21, Tong'an Avenue East Road, Tong'an Village, Dongfeng, Zhongshan , Guangdong, China.
          </p>
        </div>

        <div>
          <h3 class="text-xl font-bold mb-4 text-white">XIAO LAN</h3>
          <p class="text-sm text-gray-400">
            <i class="fa fa-building mr-2"></i> DEER GIFTS CO., LTD.<br />
            #607, Building 4, Tianji Park, Xiaolan, Zhongshan, Guangdong, China.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  data () {
    return {
    }
  },
  methods: {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/footer/FooterN.vue